import { render, staticRenderFns } from "./BrochurePhotoPicker.vue?vue&type=template&id=55107d2a&scoped=true"
import script from "./BrochurePhotoPicker.vue?vue&type=script&lang=js"
export * from "./BrochurePhotoPicker.vue?vue&type=script&lang=js"
import style0 from "./BrochurePhotoPicker.vue?vue&type=style&index=0&id=55107d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55107d2a",
  null
  
)

export default component.exports